'use client';

import type { AnalyticEvents, AnalyticValues } from '~/const/appConst';
import { useEffect } from 'react';

export const DataLayer = ({
  value,
  event,
}: {
  value: AnalyticValues;
  event: AnalyticEvents;
}) => {
  useEffect(() => {
    window.dataLayer?.push({ value, event });
  }, []);

  return null;
};
